module.exports = __webpack_public_path__ + "assets/159dddbadda1f6d6b758abc356590269.png";